import { Mail, Linkedin, Github } from "lucide-react";
import { Link } from "react-router-dom";
import { useSiteContent } from "@/context/ContentContext";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  const { footer } = useSiteContent();
  return (
    <footer className="border-t border-black/[0.08] bg-[var(--ink-950)]">
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md border border-emerald-400/40 bg-emerald-600/10 font-display text-sm font-bold text-emerald-700">
                SX
              </span>
              <span className="font-display text-[15px] font-semibold tracking-tight text-[color:var(--text-primary)]">
                {footer.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-tertiary">
              {footer.bio}
            </p>
            <p className="mt-4 font-mono-tech text-[11px] text-tertiary">
              {footer.techline}
            </p>
          </div>

          <div className="flex gap-12 sm:gap-16">
            <div className="flex flex-col gap-4">
              <span className="text-xs font-semibold uppercase tracking-wider text-tertiary">
                Esplora
              </span>
              <button
                onClick={() => scrollTo("#lavori")}
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Lavori
              </button>
              <button
                onClick={() => scrollTo("#processo")}
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Processo
              </button>
              <button
                onClick={() => scrollTo("#investimento")}
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Investimento
              </button>
              <Link
                to="/blog"
                data-testid="footer-blog-link"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Blog
              </Link>
              <Link
                to="/prenota"
                data-testid="footer-prenota-nav"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Prenota una call
              </Link>
              <button
                onClick={() => scrollTo("#contatto")}
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Contatto
              </button>
            </div>

            <div className="flex flex-col gap-4">
              <span className="text-xs font-semibold uppercase tracking-wider text-tertiary">
                Legale
              </span>
              <Link
                to="/privacy"
                data-testid="footer-privacy-nav"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Privacy
              </Link>
              <Link
                to="/termini"
                data-testid="footer-termini-nav"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Termini
              </Link>
              <Link
                to="/cookie"
                data-testid="footer-cookie-nav"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Cookie
              </Link>
              <Link
                to="/area-clienti"
                data-testid="footer-clienti-nav"
                className="text-left text-sm text-secondary transition-colors hover:text-[color:var(--text-primary)]"
              >
                Area clienti
              </Link>
            </div>
          </div>

          <div className="flex gap-3">
            {[
              { icon: Mail, label: "Email", href: "#contatto", scroll: true },
              { icon: Linkedin, label: "LinkedIn", href: "#" },
              { icon: Github, label: "GitHub", href: "#" },
            ].map((s) => (
              <button
                key={s.label}
                aria-label={s.label}
                onClick={() => s.scroll && scrollTo(s.href)}
                className="flex h-10 w-10 items-center justify-center rounded-lg border border-black/10 text-secondary transition-colors hover:border-emerald-400/40 hover:text-emerald-700"
              >
                <s.icon className="h-4 w-4" />
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-2 border-t border-black/[0.08] pt-6 text-xs text-tertiary sm:flex-row sm:items-center">
          <span>{"\u00a9"} {new Date().getFullYear()} {footer.copyright}</span>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-secondary">Privacy</Link>
            <Link to="/termini" data-testid="footer-termini-link" className="hover:text-secondary">Termini</Link>
            <Link to="/cookie" data-testid="footer-cookie-link" className="hover:text-secondary">Cookie</Link>
            <Link to="/prenota" data-testid="footer-prenota-link" className="text-emerald-700 hover:text-emerald-600">Prenota una call</Link>
            <Link to="/area-clienti" data-testid="footer-clienti-link" className="hover:text-secondary">Area clienti</Link>
            <Link to="/admin" className="hover:text-secondary">Area riservata</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
